/**
 * DaveScoreChart Component
 * Radar chart for 5-axis DAVE Score visualization
 */

import {
  RadarChart,
  PolarGrid,
  PolarAngleAxis,
  PolarRadiusAxis,
  Radar,
  ResponsiveContainer
} from 'recharts'

const AXIS_LABELS = {
  axis_story: 'Logic',
  axis_visual: 'Visuals',
  axis_excitement: 'Excitement',
  axis_emotion: 'Emotion',
  axis_fluency: 'Fluency'
}

const AXIS_LABELS_JP = {
  axis_story: '脳 (Logic)',
  axis_visual: '目・耳 (Visuals)',
  axis_excitement: '手汗 (Excitement)',
  axis_emotion: '心 (Emotion)',
  axis_fluency: '時間 (Fluency)'
}

export function DaveScoreChart({ scoreDetail, showLabelsJP = true }) {
  const labels = showLabelsJP ? AXIS_LABELS_JP : AXIS_LABELS

  const data = Object.entries(scoreDetail || {}).map(([key, value]) => ({
    axis: labels[key] || key,
    value: value || 0,
    fullMark: 20
  }))

  // スコアがすべて0の場合はプレースホルダーを表示
  const hasScore = data.some(d => d.value > 0)

  if (!hasScore) {
    return (
      <div className="radar-chart-container">
        <div className="empty-state" style={{ padding: '40px 0' }}>
          <div style={{ fontSize: '2rem', opacity: 0.3 }}>📊</div>
          <p style={{ marginTop: '8px', fontSize: '0.875rem' }}>
            未評価
          </p>
        </div>
      </div>
    )
  }

  return (
    <div className="radar-chart-container">
      <ResponsiveContainer width="100%" height={250}>
        <RadarChart data={data} margin={{ top: 20, right: 30, bottom: 20, left: 30 }}>
          <PolarGrid
            stroke="rgba(255, 255, 255, 0.1)"
            strokeDasharray="3 3"
          />
          <PolarAngleAxis
            dataKey="axis"
            tick={{ fill: 'rgba(255, 255, 255, 0.7)', fontSize: 10 }}
            tickLine={false}
          />
          <PolarRadiusAxis
            angle={90}
            domain={[0, 20]}
            tick={{ fill: 'rgba(255, 255, 255, 0.4)', fontSize: 10 }}
            tickCount={5}
            axisLine={false}
          />
          <Radar
            name="DAVE Score"
            dataKey="value"
            stroke="#00f2ea"
            fill="url(#radarGradient)"
            fillOpacity={0.5}
            strokeWidth={2}
          />
          <defs>
            <linearGradient id="radarGradient" x1="0" y1="0" x2="1" y2="1">
              <stop offset="0%" stopColor="#00f2ea" stopOpacity={0.8} />
              <stop offset="100%" stopColor="#ff0055" stopOpacity={0.6} />
            </linearGradient>
          </defs>
        </RadarChart>
      </ResponsiveContainer>
    </div>
  )
}

export function DaveScoreSliders({ scoreDetail, onChange }) {
  const labels = AXIS_LABELS_JP

  const handleChange = (key, value) => {
    onChange?.({
      ...scoreDetail,
      [key]: parseInt(value, 10)
    })
  }

  const total = Object.values(scoreDetail || {}).reduce((sum, v) => sum + (v || 0), 0)

  return (
    <div className="dave-score-sliders">
      <div className="dave-score-container">
        <div className="dave-score-total">{total}</div>
        <div className="dave-score-label">/ 100 points</div>
      </div>

      {Object.entries(labels).map(([key, label]) => (
        <div key={key} className="form-group">
          <label className="form-label">{label}</label>
          <div className="slider-container">
            <input
              type="range"
              className="slider"
              min="0"
              max="20"
              value={scoreDetail?.[key] || 0}
              onChange={(e) => handleChange(key, e.target.value)}
            />
            <span className="slider-value">{scoreDetail?.[key] || 0}</span>
          </div>
        </div>
      ))}
    </div>
  )
}

export default DaveScoreChart
